import { call } from "redux-saga/effects";

import { Api } from "@/utils";

/**
 * Generates default light groups for an organization via the API.
 *
 * @param root0 - The action payload.
 * @param root0.organizationId - The organization ID to generate defaults for.
 * @returns The API response.
 * @yields Calls the API to generate default light groups.
 */
function* generateDefaultLightGroups({ organizationId }) {
    return yield call(
        Api.put,
        `v1/default-control-groups/organization-id/${organizationId}/generate`,
    );
}

export default generateDefaultLightGroups;
